import { useEffect, useState } from 'react';

import client from '../api/client';

// Debounced product-name filter for inline pickers (e.g. the print
// designer's product-link dialog) — live results as the admin types, no
// explicit search submit like useAdminProducts' page. Unlike that page,
// an empty query still returns a page of products (so the dialog isn't
// empty on open) rather than nothing.
export default function useProductSearch(query, { limit = 24, debounceMs = 300, enabled = true } = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    setLoading(true);
    const q = query.trim();
    const timer = setTimeout(() => {
      const params = { limit, includeInactive: true };
      if (q) params.q = q;
      client
        .get('/product', { params })
        .then(({ data }) => {
          if (active) setItems(Array.isArray(data?.items) ? data.items : []);
        })
        .catch(() => {
          if (active) setItems([]);
        })
        .finally(() => {
          if (active) setLoading(false);
        });
    }, debounceMs);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [query, limit, debounceMs, enabled]);

  return { items, loading };
}
